import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { CompanyInfoModel } from '../models/company-info.model';
import { CompanyActivitiesModel } from '../models/company-activities.model';
import { CompanyContactsModel } from '../models/company-contacts.model';
import { CompanyOpportunitiesModel } from '../models/company-opportunities.model';
import { CompanyStatsModel } from '../models/company-stats.model';
import { environment} from '../../../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CompanyDashboardService {

  constructor(private http:HttpClient) { }


  getCompanyInfo(projectId: number, companyId: number){
    return this.http.get<CompanyInfoModel[]>(
      environment.baseUrl + '/reportsfetcher/api/company/dashboard/getCompanyInfo?projectId='+projectId+'&companyId='+companyId
    );
  }

  getCompanyContacts(projectId: number, companyId: number){
    return this.http.get<CompanyContactsModel>(
      environment.baseUrl + '/reportsfetcher/api/company/dashboard/getContacts?projectId='+projectId+'&companyId='+companyId
    );
  }

  getCompanyOpportunities(projectId: number, companyId: number){
    return this.http.get<CompanyOpportunitiesModel[]>(
      environment.baseUrl + '/reportsfetcher/api/company/dashboard/getOpportunities?projectId='+projectId+'&companyId='+companyId
    );
  }

  getCompanyActivities(projectId: number, companyId: number){
    return this.http.get<CompanyActivitiesModel>(
    environment.baseUrl + '/reportsfetcher/api/company/dashboard/getActivities?projectId='+projectId+'&companyId='+companyId
    );
  }

  getCompanyStats(projectId: number, companyId: number){
    return this.http.get<CompanyStatsModel[]>(
      environment.baseUrl + '/reportsfetcher/api/company/dashboard/getStats?projectId='+projectId+'&companyId='+companyId
    );
  }

  getFiles(projectId:number,moduleType:number,activityId:number){
    return this.http.get(
     environment.baseUrl + '/reportsfetcher/api/company/dashboard/getFiles?projectId='+projectId+'&moduleType='+moduleType+'&activityId='+activityId
    );
  }

  getConversations(projectId:number,compId:number){
    return this.http.get(
      environment.baseUrl + '/reportsfetcher/api/company/dashboard/getConversation?projectId='+projectId+'&compId='+compId
     );
}
}